import {
  DC_Repositories_Base_Enumerations_BusinessUnit,
  DC_Repositories_Base_Enumerations_Label,
  RequestDataDC_Customers_Client_Models_CustomerDiscontinueIntakeRequestModel,
  ResponseDataDC_Customers_Client_Models_CustomerDiscontinueIntakeV2ResponseModel,
} from '@monorepo-types/dc';

import { request } from '../client';
import type { ApiRequestConfig } from '../client/types';

type PostCustomerDiscontinueIntakeSecure = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  customerId: number;
  requestBody: RequestDataDC_Customers_Client_Models_CustomerDiscontinueIntakeRequestModel;
};
/**
 * Post customer discontinue intake V2 (secure)
 *
 * @returns ResponseDataDC_Customers_Client_Models_CustomerDiscontinueIntakeV2ResponseModel Success
 */
export function postCustomerDiscontinueIntakeSecure(
  { businessUnit, label, customerId, requestBody }: PostCustomerDiscontinueIntakeSecure,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseDataDC_Customers_Client_Models_CustomerDiscontinueIntakeV2ResponseModel> {
  return request(
    {
      method: 'POST',
      path: `/dxpweb/public/v2/${businessUnit}/${label}/customers/${customerId}/discontinue/intake`,
      body: requestBody,
      errors: { 400: 'Bad Request', 404: 'Not Found' },
    },
    requestConfig,
  );
}
